// ============================================
// chartConstants.js — tuning numbers / option tables declared at module
// scope by FootprintChartCanvas that are NOT part of utils/chartUtils.
// (chartUtils holds the geometry/format constants shared with other files;
// these are UI/interaction tunables local to the footprint chart.)
// ============================================

// ── Damped-follow tuning ──
// FOLLOW_DAMP_K: per-frame trail tightness for follow mode. Each draw
// frame, center moves this fraction of the remaining distance to price.
// 1.0 = pin price exactly (Bookmap-like); lower = floatier trail. 0.18 ≈
// 63% settle in ~5 frames (~80ms @60Hz) — immediate but never a snap.
export const FOLLOW_DAMP_K = 0.10
// FOLLOW_OFFSET_FRAC: where price sits in the viewport, as a fraction of
// the rendered half-range. 0 = dead center; positive rides price LOW
// (context above). Try ~0.33 for a bottom-third feel.
export const FOLLOW_OFFSET_FRAC = 0
// FOLLOW_EDGE_FRAC: hold-until-edge trigger for follow mode. The center HOLDS
// (zero per-frame drift) until price wanders past this fraction of the visible
// half-range from the held center — then it recenters ONCE (a damped glide
// that puts price back at FOLLOW_OFFSET_FRAC) and holds again. 0.90 = fire
// when price crosses 90% of the way to the top/bottom edge. History note: the
// ORIGINAL discrete policy anchored price AT the edge on correction, so every
// new low re-breached instantly (edge-walk lurch); recentring FULLY buys a
// whole half-band of stillness per trigger, which is what makes hold-until-
// edge livable this time.
export const FOLLOW_EDGE_FRAC = 0.90

// FP_CELL_LOD_MIN_PX: level-of-detail threshold for the footprint cells.
// Below this many pixels per candle, the per-level buy/sell cells are
// sub-pixel smears — you pay the chart's heaviest loop (animation
// bookkeeping, LUT, transforms, inflated fillRects per level per candle per
// frame) to paint detail no eye can resolve. Under the threshold, footprint
// mode borrows candle mode's rendering: cells skipped, proper candlesticks
// drawn by the existing body/wick pass. Full footprint detail returns the
// instant a candle is wide enough to read again. 7px ≈ where the split
// buy/sell bars stop being distinguishable.
export const FP_CELL_LOD_MIN_PX = 7

// Timeframe options for TimeframeSelect (seconds → label).
export const TF_OPTIONS = [
  { value: 15, label: '15s' },
  { value: 30, label: '30s' },
  { value: 60, label: '1m' },
  { value: 300, label: '5m' },
  { value: 900, label: '15m' },
  { value: 1800, label: '30m' },
  { value: 3600, label: '1h' },
  { value: 14400, label: '4h' },
  { value: 86400, label: '1d' },
]